// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Tpue","imageUploader":"EGiftCard_imageUploader__3Xa2Z"};